import { Navigation } from "./navigation";
import { Helpers } from "./helpers/helpers";
import Cookies, {CookieAttributes} from "js-cookie";
import {ConsentCookie} from "./consent-banner";
import {FormHelpers} from "./helpers/form-helpers";

export class Header {	
	mainHeader: Element;
	searchForm: Element;
	searchBox: HTMLFormElement;
	mobileSearchButton: Element;
	mobileSearchContainer: Element;
	languageSelectors: NodeListOf<Element>;
	cultureDetectionViolators: NodeListOf<Element>;
	private cultureDetectionViolatorsWrap: HTMLElement;
	constructor(bindEvents = false) {
		this.mainHeader = document.querySelector('.main-header');
		this.searchForm = document.querySelector('.header-search-form');
		this.searchBox = document.querySelector('.header-search-form input');
		this.mobileSearchButton = document.querySelector('header .mobile-search a');
		this.mobileSearchContainer = document.querySelector('.mobile-search-form');
		this.languageSelectors = document.querySelectorAll('.language-selector');
		this.cultureDetectionViolatorsWrap = document.querySelector('.mobile-culture-detector');
		this.cultureDetectionViolators = document.querySelectorAll('.culture-detection-violator');

		if (bindEvents) {
			this.bindEvents();
		}
	}

	bindEvents(): void {

		//bind live chat trigger 
		document.querySelectorAll('.live-chat-trigger').forEach(element=> {
			element.addEventListener('click', (e)=>{
				e.preventDefault();
				
				if (window.LiveChatWidget) {
					window.LiveChatWidget.call("maximize");
				}
			})
		})
		//bind desktop search
		this.searchForm?.addEventListener('submit', (formEvent) => {
			const searchText = this.searchBox.value;
			if (searchText !== '' && this.mainHeader.classList.contains('search-open')) {
				return true;
			}

			formEvent.preventDefault();
			this.openHeaderSearchBox(true);
			return false;
		});

		//bind mobile search 
		this.mobileSearchButton?.addEventListener('click', (e) => {
			e.preventDefault();
			this.mobileSearchContainer.classList.toggle('open');
			const navigation = new Navigation();
			navigation.closeExpandedNavigation();
		});

		//bind country selector
		if (!Helpers.isNullOrUndefined(this.languageSelectors)) {
			this.languageSelectors.forEach(languageSelector => {


				const optionsToggle = languageSelector.querySelector('.options-toggle');
				const languageOptions = languageSelector.querySelector('.language-options') as HTMLElement;
				const languageOptionsSelection = languageSelector.querySelector('.language-option-selection') as HTMLElement;
				const languageAccordion = languageSelector.querySelector('.language-accordion') as HTMLElement;
				optionsToggle.addEventListener('click', () => {
					optionsToggle.classList.toggle('active');
					languageOptions.classList.toggle('open');
				});

				if (!Helpers.isNullOrUndefined(languageOptionsSelection)) {
					languageOptions.querySelectorAll('li > a').forEach(option => {
						option.addEventListener('click',
							(e) => {
								e.preventDefault();
								languageOptions.querySelectorAll('li').forEach(aEl => aEl.classList.remove('active'));
								const a = e.target as HTMLElement;
								a.closest('li').classList.add('active');
								languageOptionsSelection.innerHTML = a.parentNode.querySelector('.options').innerHTML;
							});
					});
				}

				if (!Helpers.isNullOrUndefined(languageAccordion)) {
					const accordians = languageAccordion.querySelectorAll('.accordian-item');
					const accordianToggles = languageAccordion.querySelectorAll('li > a');
					accordianToggles.forEach(option => {
						option.addEventListener('click',
							(e) => {
								e.preventDefault();
								accordians.forEach(element => {
									element.classList.remove('active');
									element.querySelector('.options').classList.remove('active');
								});
							
								option.parentElement.classList.add('active');
								option.parentElement.querySelector('.options').classList.add('active');
							});
					});
				}
			});
			
			//bind culture violator detection
			const cookieKey = "hide-violator";
			let cookie = Cookies.get(cookieKey);			
		
			
			if (!cookie) {

				FormHelpers.getAjax(`/culture/detect?t=${new Date().getTime()}`, response => {
					const cultureInfo = JSON.parse(response) as any;					;
					
					if (!cultureInfo.cultureDetectionEnabled) return;
					
					if (cultureInfo && cultureInfo.cultureName && cultureInfo.cultureCode !== Helpers.getCurrentCulture() 
						|| (cultureInfo.cultureCode === "en-US" && window.location.host.indexOf('tensarinternational.com') !== -1)) {

						const pagesToSkipViolator = ["/dop"];
						if (pagesToSkipViolator.indexOf(window.location.pathname) !== -1) return;

						this.cultureDetectionViolatorsWrap.classList.remove('d-none');
						this.cultureDetectionViolators.forEach(violator => {							
							violator.querySelectorAll('.user-culture')
								.forEach(c => c.innerHTML = cultureInfo.countryName);				
							violator.querySelectorAll('.accept')
								.forEach(c => c.setAttribute("href",cultureInfo.url));
							
							violator.classList.remove('d-none')
							
							violator.querySelector('.ignore')
								.addEventListener('click', (e) => {
									e.preventDefault();
									violator.classList.add('d-none');
									this.cultureDetectionViolatorsWrap.classList.add('d-none');
									let remember = violator.querySelector('input[type=checkbox]:checked');
									if (remember) {
										const cookieAttributes: CookieAttributes = {
											expires: 150,
											sameSite: "none",
											secure: true
										};
										Cookies.set(cookieKey, "true", cookieAttributes)
									}
								});
						});
					}

				}, (error) => console.warn(error));
				
			}
			

		}
	}

	openHeaderSearchBox(toggleIfOpen: boolean, addCloseListener = true) {
		if (toggleIfOpen) {
			this.mainHeader.classList.toggle('search-open');
		} else {
			this.mainHeader.classList.add('search-open');
		}
		if (addCloseListener) {
			const outsideClickListener = (e: MouseEvent) => {
				const clickedInForm = this.searchForm.contains(e.target as Node);
				if (!clickedInForm && this.mainHeader.classList.contains('search-open')) {
					this.mainHeader.classList.toggle('search-open');
				}
				document.removeEventListener('click', outsideClickListener);
			}

			document.addEventListener('click', outsideClickListener);
		}
	}

	closeSearchBox(clearInput = false) {
		this.mainHeader.classList.remove('search-open');
		this.mobileSearchContainer.classList.remove('open');
		if (clearInput) {
			this.searchBox.value = "";
			this.searchForm.querySelector('button').classList.remove('typing');
		}
	}

}